import { api } from "./configs/axiosConfigs"

export const IntakeCartAPI = {
    get: async (data?: object) => {
        const response = await api.get(
            '/intake-cart', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    create: async (data: object) => {
        const response = await api.post(
            '/intake-cart/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    updateQuantity: async (id: number, data: object) => {
        const response = await api.patch(
            `/intake-cart/update-quantity/${id}`, data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    delete: async (id: number) => {
        const response = await api.delete(
            `/intake-cart/product/${id}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
}